<script lang="ts">
    import {exists} from 'shared/utils/custom-utils';
    import {slide} from 'svelte/transition';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let title = '';
    export let headingLine = false;
    export let collapsible = false;
    export let collapsedByDefault = false;
    export let headingType: 'span' | 'h1' | 'h2' | 'h3' | 'h4' = 'span';
    export let additionalClasses = '';

    const collapsibleSlideAnimParams = {axis: 'y', duration: 250} as const;

    let collapsed = collapsedByDefault;

    const handleCollapsibleClick = () => {
        if (!collapsible) {
            return;
        }

        collapsed = !collapsed;
    }
</script>

<section class="kp-titled-section {additionalClasses}">
    {#if exists($$slots.heading)}
        <slot name="heading"/>
    {:else}
        <svelte:element this="{headingType}"
                        class="heading"
                        role="button"
                        aria-expanded={!collapsed || !collapsible}
                        tabindex="0"
                        class:collapsible={collapsible}
                        on:click={handleCollapsibleClick}>
            {title}

            <span class="fill-width-spacer" class:separator={headingLine}></span>

            {#if collapsible}
                <div class="icon-container" class:opened={!collapsed}>
                    <UIcon icon="angle-small-right" color="inherit"/>
                </div>
            {/if}
        </svelte:element>
    {/if}

    {#if !collapsed}
        <div class="content-container" transition:slide={collapsibleSlideAnimParams}>
            <slot/>
        </div>
    {/if}
</section>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .kp-titled-section {
        width: 100%;
        display: flex;
        flex-direction: column;
        min-width: 0;

        .heading {
            margin: 0;
            width: 100%;
            display: flex;
            align-items: center;
            gap: @spacing-ml;
            font-weight: 500;

            .fill-width-spacer {
                flex: 1;

                &.separator {
                    height: 1px;
                    border-bottom: 1px solid @themed-border-default;
                }
            }

            &.collapsible {
                margin: 0 calc(-1 * @spacing-sm);
                padding: 0 @spacing-sm;
                width: calc(100% + 2 * @spacing-sm);
                cursor: pointer;
                background: none;
                border: none;
                outline: none;
                border-radius: @border-radius-default;
                transition: background-color 0.2s ease-in-out;

                &:hover {
                    background-color: @themed-panel-bg;
                }
            }

            .icon-container {
                color: @themed-text-muted;
                transition: rotate 0.2s ease-in-out, color 0.2s ease-in-out;

                &.opened {
                    rotate: -90deg;
                    color: @themed-text-default;
                }
            }
        }

        .content-container {
            margin-top: @spacing-ml;
            display: flex;
            gap: @spacing-ml;
            flex-direction: column;
            width: 100%;
        }
    }
</style>